<emperor-card-header
  class="emperor-dialog-header-container"
  [color]="cardHeaderColor"
>
  <div
    tabindex="-1"
    [attr.cdkFocusInitial]="enableAutoFocus ? true : null"
    class="emperor-dialog-title"
    *ngIf="title"
  >
    {{ title }}
  </div>
  <emperor-button
    [uiButtonType]="EmperorUIButtonTypes.Icon"
    [color]="buttonColor"
    *ngIf="shouldShowClose"
    emperorDialogClose
    ariaLabel="Close dialog"
  >
    <emperor-icon [ariaHidden]="true" [name]="'close_1'"></emperor-icon>
  </emperor-button>
</emperor-card-header>
